import { z } from 'zod';
export const aliasSchema = z.object({
  address: z.string().min(1, 'Alias is required').email('Enter a valid address'),
  target: z.string().min(1, 'Target is required').email('Enter a valid target mailbox'),
  enabled: z.boolean().default(true),
});
export type AliasFormValues = z.infer<typeof aliasSchema>;
